// Keep this file dependency-free and import it FIRST in `src/index.js`.
// Some third-party browser bundles (e.g. chart libs) may reference `process`
// at module init time (before `index.js` body executes).
const root = typeof window !== 'undefined' ? window : {};

if (typeof root.process === 'undefined') {
  root.process = { env: {} };
}
